import { showMsg } from '@/utils/snackbar'

export default {
    mounted(el) {

        let timeout = null

        el.addEventListener('input', (e) => {

            const value = e.target.value

            // فقط جلوگیری از فارسی و عربی
            const sanitized = value.replace(/[\u0600-\u06FF]/g, '')

            if (value !== sanitized) {

                if (!timeout) {

                    showMsg(
                        'ورود حروف فارسی مجاز نیست',
                        'red'
                    )

                    timeout = setTimeout(() => {
                        timeout = null
                    }, 1500)
                }

                e.target.value = sanitized

                e.target.dispatchEvent(
                    new Event('input', { bubbles: true })
                )
            }

        })
    }
}
